import React, { useEffect, useState } from "react";
import { Typography, Box, Grid } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import {
    InputLabel,
    MenuItem,
    Select
} from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import { Button } from "@mui/material";
import classes from "./availabilitySelections.module.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import Cookie from "js-cookie";
import SnackBar from "../../Shared/Snackbar/Snackbar";
import { IsTokenValid } from "../../Shared/Utill/AuthUtil";
import {KeyDaysIcon,PTOIcon,SpecialEventIcon,UnavailableDaysIcon,AccomodationsIcon} from  '../../Resources/availabilityicon/AvailabilityIcons';
import NotificationView from "../../Shared/Notification/NotificationView";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmpty, toUpperCaseString  } from "../../Shared/Utill/Utills";
import { messages } from "../../Shared/Messages/ErrorMessages";

const AvailabilitySelectionsDailyPopup = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);
    const [unavailableDialog, setunavailableDialog] = useState(false);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const [startDropDown1, setstartDropDown1] = useState([]);
    const [endDropDown1, setendDropDown1] = useState([]);
    const [startDropDown2, setstartDropDown2] = useState([]);
    const [endDropDown2, setendDropDown2] = useState([]);
    const [checkedSplit, setCheckedSplit] = React.useState(props.eventdata.avlDayStart2 !== null || props.eventdata.avlDayEnd2 !== null ? true : false);
    const [checkedAvailable, setcheckedAvailable] = React.useState(toUpperCaseString(props.eventdata.avlDayStart1) === 'OFF' && toUpperCaseString(props.eventdata.avlDayEnd1) === 'OFF' ? true : false);
    const history = useNavigate();
    const languageDetails = useSelector((state) => state.selectedLanguage.selectedLanguageData);

    let dayName = props.eventdata.svcCal_DayName.toLowerCase();
    //alert(dayName)
    let startEdit = dayName + "_start_editable";
    let endEdit = dayName + "_end_editable";
    let isEditObj = {
        startEdit : props.rulesData[startEdit],
        endEdit: props.rulesData[endEdit]
    }

    let defaultStart = "OPEN";
    let defaultEnd = "CLOSE";
    if(props.eventdata.svcAccom_hasAccom === 1 && (toUpperCaseString(props.eventdata.svcAccom_accomType) === "START" || toUpperCaseString(props.eventdata.svcAccom_accomType) === "BOTH") ){
        defaultStart = props.eventdata.svcAccom_start;
    }
    if(props.eventdata.svcAccom_hasAccom === 1 && (toUpperCaseString(props.eventdata.svcAccom_accomType) === "END" || toUpperCaseString(props.eventdata.svcAccom_accomType) === "BOTH") ){
        defaultEnd = props.eventdata.svcAccom_end;
    }
    
    // set dropdowndefault value
    const [startDropDown1Value, setstartDropDown1Value] = useState(toUpperCaseString(props.rulesData[startEdit]) === "N" ? defaultStart : props.eventdata.avlDayStart1);
    const [endDropDown1Value, setendDropDown1Value] = useState((toUpperCaseString(props.rulesData[endEdit]) === "N" && !checkedSplit) ? defaultEnd : props.eventdata.avlDayEnd1);
    const [startDropDown2Value, setstartDropDown2Value] = useState(props.eventdata.avlDayStart2);
    const [endDropDown2Value, setendDropDown2Value] = useState((toUpperCaseString(props.rulesData[endEdit]) === "N" && checkedSplit) ? defaultEnd : props.eventdata.avlDayEnd2);
    
    //console.log(isEditObj)

    console.log("event data", props.eventdata);
    console.log("rule data", props.rulesData);
    console.log("app controls", props.appControls)
    console.log("fsc data", props.fscData)

    const [isDropEditable, setIsDropEditable] = useState(isEditObj);

    useEffect(() => {
        getDialogStyleVersion();
    },[window.innerWidth]);

    useEffect(() => {

        // call api for dropdowns
        /*let data = {
            eventCanSelectPartial: "y",
            eventShiftSelectXminsApart: 60,
            dayDate: "2023-01-01",
            dayHoursStart: "05:00 PM",
            dayHoursEnd: "03:00 AM"
        } */
        
        /*if (IsTokenValid(colleagueTKN)) {
            let homeUrl = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_UI_BASE_URL
            window.location.replace(`${homeUrl}login`)
          } // isTokenValid */

          console.log("is drop", isDropEditable)
        // set start and end drop down values based on editable
      /*  if(isDropEditable.startEdit === 'n') {
            setstartDropDown1Value("OPEN")
        }
        
        if(isDropEditable.endEdit === 'n') {
            setendDropDown1("CLOSE")
        } */


        //let controls = props.appControls.find(x => x.ctlName === "avlShiftSelectXminsApart")

        let data = getDropDownPayload();
        console.log("Amount of rerenders")
         axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_DAILY_AVAIL_DROP_DOWN}`, 
         data,
          {
            headers:{
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' + colleagueTKN,
          }}
          ).then((response) => {
        //TODO: uncomment below line to run local and comment above line 
       
            setstartDropDown1(response.data.start1);
            setendDropDown1(response.data.end1);
            //setstartDropDown2(response.data.start1);
            //setendDropDown2(response.data.end1);
            setstartDropDown2(response.data.start2);
            setendDropDown2(response.data.end2);
            
            if(!response.data.start1.includes(startDropDown1Value)) {
                setstartDropDown1Value(null)
            }
            if(!response.data.end1.includes(endDropDown1Value)) {
                setendDropDown1Value(null)
            } 

            if(!response.data.start2.includes(startDropDown2Value)) {
                setstartDropDown2Value(null)
            }
            if(!response.data.end2.includes(endDropDown2Value)) {
                setendDropDown2Value(null)
            } 
        })
            .catch((error) => {
                //catch
                setAlertOpen({
                    open: true,
                    severity: "error",
                    message : "Please logout and try again",
                  }) 
                  if(error.message === 'Network Error') {
                    history("/somethingwentwrong", {state:`Please logout and try again `})
                  } else {
                 history("/somethingwentwrong", {state:`${constants.WFM_GET_DAILY_AVAIL_DROP_DOWN}...failed`})
                  }
            });

        dialog.show();

    }, []);

    const getDropDownPayload = () => {
        let controls = props.appControls.find(x => x.ctlName === "avlShiftSelectXminsApart");
        let avlShiftSelectXminsApart = controls.ctlValue01;
        let timeStartStart = "12:00 AM";
        let timeStartEnd = props.rulesData.startselect_stops_at;
        let bolIncludeOpen = 1;
        let timeEndStart = props.rulesData.endselect_starts_at;
        let timeEndEnd = toUpperCaseString(props.rulesData.end_my_day_is_active) === 'N' ? "11:59 PM" : props.rulesData.end_my_day_at_time;
        let bolIncludeClose = 1;

       // dummy props for testing
       /* let svcAccom_hasAccom = 1;
        let svcAccom_start = "02: 00 PM";
        let svcAccom_end = "04: 00 PM";
        let svcAccom_accomType = "BOTH"; */

        //props from parent page
        let svcAccom_hasAccom = props.eventdata.svcAccom_hasAccom;
        let svcAccom_start = props.eventdata.svcAccom_start;
        let svcAccom_end = props.eventdata.svcAccom_end;
        let svcAccom_accomType = props.eventdata.svcAccom_accomType;
        

        // check if accommodation is true
        if(svcAccom_hasAccom === 1) {
            // timeEndEnd smaller between rules and accom_end will be passed to api 
            let endTime = timeEndEnd;
            if(svcAccom_end !== null ) {
                if(new Date ('1/1/1900 ' + endTime) > new Date ('1/1/1900 ' + svcAccom_end) ) {
                 endTime = svcAccom_end;
                }
            }

            // split shift is  allowed
            if(toUpperCaseString(props.rulesData.allow_splitshifts) === 'Y') {
                if(toUpperCaseString(svcAccom_accomType) === "START") {
                    timeStartStart = svcAccom_start;
                    timeEndStart = svcAccom_start;
                    bolIncludeOpen = 0;
                } else if (toUpperCaseString(svcAccom_accomType) === "END") {
                    timeEndEnd = endTime;
                    bolIncludeClose = 0;
                } else if (toUpperCaseString(svcAccom_accomType) === "BOTH") {
                    timeStartStart = svcAccom_start;
                    timeStartEnd = endTime;
                    bolIncludeOpen = 0;
                    timeEndStart = svcAccom_start;
                    timeEndEnd = endTime;
                    bolIncludeClose = 0;
                }               

            } else {               

                if(toUpperCaseString(svcAccom_accomType) === "START") {
                    timeStartStart = svcAccom_start;
                    timeStartEnd = svcAccom_start;
                    bolIncludeOpen = 0;
                } else if (toUpperCaseString(svcAccom_accomType) === "END") {
                    timeEndStart = endTime;
                    timeEndEnd = endTime;
                    bolIncludeClose = 0;
                } else if (toUpperCaseString(svcAccom_accomType) === "BOTH") {
                    timeStartStart = svcAccom_start;
                    timeStartEnd = svcAccom_start;
                    bolIncludeOpen = 0;
                    timeEndStart = endTime;
                    timeEndEnd = endTime;
                    bolIncludeClose = 0;
                }

            } // split shift not allowed

        } 
        return {
            avlShiftSelectXminsApart: avlShiftSelectXminsApart,
            timeStartStart: timeStartStart,
            bolIncludeOpen: bolIncludeOpen,
            timeStartEnd: timeStartEnd,  //"01:00 PM",
            timeEndStart: timeEndStart,   //"06:00 PM",
            timeEndEnd: timeEndEnd,
            bolIncludeClose: bolIncludeClose
        }
       
    }


    const handleChangeSplit = (event) => {
        setCheckedSplit(event.target.checked);
        if(toUpperCaseString(isDropEditable.endEdit) === "N" && event.target.checked === true){
            setendDropDown1Value(null);
            if(props.eventdata.svcAccom_hasAccom === 0) {
            setendDropDown2Value("CLOSE");
            } else {
                setendDropDown2Value(props.eventdata.svcAccom_end);
            }
        }
        if(toUpperCaseString(isDropEditable.endEdit) === "N" && event.target.checked === false){
            if(props.eventdata.svcAccom_hasAccom === 0) {
            setendDropDown1Value("CLOSE");
            } else {
              setendDropDown1Value(props.eventdata.svcAccom_end);
           }
        }

    };

    const handleChangeAvailable = (event) => {
        if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
            setAlertOpen({
              open: true,
              severity: 'error',
              message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
            })
            return;
          }
        setcheckedAvailable(event.target.checked);
        if (event.target.checked === true) {
            setunavailableDialog(true);
        } else {
            setstartDropDown1Value(startDropDown1[0])
            setendDropDown1Value("CLOSE")
            setunavailableDialog(false);
        }
    };


    const handleChangeDropdown = (event, dropdownName) => {
        if (dropdownName === "startDropDown1Value") {
            setstartDropDown1Value(event.target.value);
            if(event.target.value === "DAY OFF"){
                setendDropDown1Value(event.target.value)
            }
        } else if (dropdownName === "endDropDown1Value") {
            setendDropDown1Value(event.target.value);
            if(event.target.value === "DAY OFF"){
                setstartDropDown1Value(event.target.value)
            }
        } else if (dropdownName === "startDropDown2Value") {
            setstartDropDown2Value(event.target.value);
        } else if (dropdownName === "endDropDown2Value") {
            setendDropDown2Value(event.target.value);
        }

    };

    const handleSave = () => {
        if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
            setAlertOpen({
              open: true,
              severity: 'error',
              message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
            })
            return;
          }
        let error  = '';
        let avlDayAccomChgdToDayOff = 0;
        if(props.eventdata.svcAccom_hasAccom === 1 && checkedAvailable ){
            avlDayAccomChgdToDayOff = 1;
        }
        //call the save api
        let data = {
            checkRulesOnly:"N",
            ruleToCheck:"ALL",
            dayNbr: props.eventdata.dayNbr,            
            ascNbr: personDetails.emplID,
            // myDiv: personDetails.mydiv,
            // myStore: personDetails.mystore,
            // myDept: personDetails.mydept,
            myDiv: personODSFuture.mydiv,
            myStore: personODSFuture.mystore,
            myDept: personODSFuture.mydept,
            fscyyyy: props.fscData.fscYyyy,
            fscww: props.fscData.fscWw,
            avlId: props.eventdata.avlId,
            avlRuleId: props.rulesData.ruleId,
            avlDayStart1: !checkedAvailable ? startDropDown1Value : "OFF",
            avlDayEnd1: !checkedAvailable ? endDropDown1Value : "OFF",
            avlDayStart2: checkedSplit && !checkedAvailable ? startDropDown2Value : null,
            avlDayEnd2: checkedSplit && !checkedAvailable ? endDropDown2Value : null,
            avlIsBase: null,
            avlIsOverride: null,
            lastUpdatedBy: personDetails.emplID,
            impersonatedBy: personDetails.impersonate_admin_id,
            arId: props.rulesData.arId,
            avlDayHasAccom: props.eventdata.svcAccom_hasAccom,
            avlDayAccomChgdToDayOff: avlDayAccomChgdToDayOff,
            avlDayAccomType: props.eventdata.svcAccom_accomType,
            avlLanguageCode: languageDetails.selected !== '' ? languageDetails.selected : 'en'
        }
        console.log("post data",data)
       /*

        if((startDropDown1Value === null || endDropDown1Value === null ) || ( (checkedSplit && props.eventdata.eventAllowSplitShifts !== 'n') && (startDropDown2Value === null || endDropDown2Value === null))) {
            error = "Start and end time should not be empty"
        } else if ((startTime1.getTime() >= endTime1.getTime()) || 
                   ((checkedSplit && props.eventdata.eventAllowSplitShifts !== 'n') && (startTime2.getTime() >= endTime2.getTime())) ||
                   ((checkedSplit && props.eventdata.eventAllowSplitShifts !== 'n') && (startTime2.getTime() <= endTime1.getTime()))
                  ){
            error = "Please select appropriate time for start and end" 
        } else if (props.eventdata.eventForceMinShiftHrs === 'y' 
                    && (Math.floor(((endTime1 - startTime1) / (1000 * 60 * 60)) % 24) < props.eventdata.eventForceMinShiftHrsAmt)
                    || ((checkedSplit && props.eventdata.eventAllowSplitShifts !== 'n') && Math.floor(((endTime2 - startTime2) / (1000 * 60 * 60)) % 24) < props.eventdata.eventForceMinShiftHrsAmt)) {
            error = "Please select a minimum of " + props.eventdata.eventForceMinShiftHrsAmt + " hours of availability."
        } */

       /* if(error !== '') {
            setAlertOpen({
                open: true,
                severity: "error",
                message : error,
              })
           // alert(error)
        } else {
            props.onSaveSuccess("success");
            props.popupClose(); */
      
        
            // insert / update new record
            axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_INSERT_DAILY_DATA}`,
             data,
             {
                headers:{
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + colleagueTKN,
              }}).then((response) => {  
                if(response.status === 202) {
                    props.onSaveSuccess("warning", response.data.message);
                } else {
                    props.onSaveSuccess("success");
                }
                props.popupClose();

            })
                .catch((error) => {
                    //catch
                    setAlertOpen({
                        open: true,
                        severity: "error",
                        message : error.response.data.message,
                      })
                    //props.onSaveSuccess("error");
                }); 
         

    }

    const handleAlertNotifClose = () => {
        setAlertOpen({});
      };



    const popupClose = () => {
        setcheckedAvailable(false);
        setunavailableDialog(false);
    }

    const popupSave = (msg) => {
        //setcheckedAvailable(false);
        props.onSaveSuccess(msg);
        setunavailableDialog(false);
        props.popupClose();
    }

    const UnavailableSwitchView = () => {
        if((!isEmpty(props.eventdata.svcKeyDay_IsKeyDay) &&
        props.eventdata.svcKeyDay_IsKeyDay.toUpperCase() === "Y" && 
        props.eventdata.svcKeyDay_IsKeyDayException.toUpperCase() === "N" ) ||
        (toUpperCaseString(isDropEditable.startEdit) === "N" || toUpperCaseString(isDropEditable.endEdit) === "N"))
        
        {
            return <></>;
        }else{
          return <FormGroup>
                     <div className={classes.unavailableHeading}>
                        <Typography >I am unavailable for this day
                         <FormControlLabel control={<Switch className={classes.unavailableSwitch} checked={checkedAvailable} onChange={handleChangeAvailable} color={"black"} />} label="" />
                         </Typography>
                        </div>
                     <br />
                    </FormGroup>  
        }
    }

    const getDialogStyleVersion = () => {
        let widthD = "45%";
        let leftMargin = "45%";
        if(window.innerWidth < 768){
            //mobile version
            widthD = "100%";
            leftMargin = "0%";
          }else if(window.innerWidth <= 1300){
            // tablet
            widthD = "75%";
            leftMargin = "13%";
          }else if(window.innerWidth > 1300){
            //desktop
            widthD = "45%";
            leftMargin = "28%";
          }
        return {
            width: widthD,
            maxWidth: widthD,
            display:"flex",
            left:leftMargin,
            minHeight: checkedSplit ? "100%" : "100%",             
        }
    }
    return (
        <div className="dialog" >
        <Dialog className={classes.dialog}

            PaperProps={{
                sx: getDialogStyleVersion(),
            }}

            open={dialog.open}
            title='Select Availability'
            onClose={props.popupClose}
        >
            <div className={classes.dialog_content}>
            <Typography><span className={classes.headingDate}>{props.eventdata.svcCal_DayName}, {props.eventdata.svcCal_MthName} {props.eventdata.svcCal_CalendarDate !== null ? props.eventdata.svcCal_CalendarDate.split("-")[2]: null} </span></Typography>
            <Typography><span className={classes.headingTime}><b>Store Hours:</b> <span translate="no"> {props.eventdata.svcStrHrs_Start} - {props.eventdata.svcStrHrs_End}</span>  </span></Typography><br />
            
            <NotificationView
                 message={props.ruleInfo.txtCustomInfoMsg}/>
            <UnavailableSwitchView/>     
            <div className={classes.columns}>
            <FormControl className={classes.column}  style={{ marginTop: 20} }>
                <InputLabel id="demo-select-basic-label">Start</InputLabel>
                <Select
                    labelId="demo-select-basic-label"
                    id="demo-select-basic"
                    label="Start"
                    value={startDropDown1Value}
                    onChange={e => handleChangeDropdown(e, "startDropDown1Value")}
                    disabled={(checkedAvailable || (toUpperCaseString(isDropEditable.startEdit) === 'N')) ? "disabled" : ''}
                    translate="no"
                >
                    {
                        startDropDown1.map(el => <MenuItem translate="no" value={el}>{el}</MenuItem>)
                    }

                </Select>
            </FormControl>
            <FormControl className={classes.column}  style={{ marginTop: 20} }>

                <InputLabel id="demo-select-basic-label">End</InputLabel>
                <Select
                    labelId="demo-select-basic-label"
                    id="demo-select-basic"
                    label="End"
                    value={endDropDown1Value}
                    onChange={e => handleChangeDropdown(e, "endDropDown1Value")}
                    disabled={((checkedAvailable || (toUpperCaseString(isDropEditable.endEdit) === 'N' && !checkedSplit))) ? "disabled" : ''}
                    translate="no"
                >
                    {
                        endDropDown1.map(el => <MenuItem translate="no" value={el}>{el}</MenuItem>)
                    }
                </Select>


            </FormControl>
            {toUpperCaseString(props.rulesData.allow_splitshifts) === 'Y' &&
            <FormControlLabel className={classes.column} control={<Switch className={classes.splitMessage} checked={checkedSplit}
                onChange={handleChangeSplit} color={"black"} />} label="Split Shift" />
            }
            </div>
            <div className={classes.columnsSplit}>       
            {(checkedSplit && toUpperCaseString(props.rulesData.allow_splitshifts) === 'Y') &&
                <>
                    <FormControl className={classes.column} style={{ marginTop: 20, minWidth: 1  }}>
                        <InputLabel id="demo-select-basic-label">Start</InputLabel>
                        <Select
                            labelId="demo-select-basic-label"
                            id="demo-select-basic"
                            label="Start"
                            value={startDropDown2Value}
                            onChange={e => handleChangeDropdown(e, "startDropDown2Value")}
                            disabled={checkedAvailable ? "disabled" : ''}
                            translate="no"
                        >
                            {
                                startDropDown2.map(el => <MenuItem translate="no" value={el}>{el}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                    <FormControl style={{marginTop: 20 }} className={classes.column}>
                        <InputLabel id="demo-select-basic-label">End</InputLabel>
                        <Select
                            labelId="demo-select-basic-label"
                            id="demo-select-basic"
                            label="End"
                            value={endDropDown2Value}
                            onChange={e => handleChangeDropdown(e, "endDropDown2Value")}
                            disabled={((checkedAvailable || (toUpperCaseString(isDropEditable.endEdit) === 'N' && checkedSplit)) ) ? "disabled" : ''}
                            translate="no"
                        >
                            {
                                endDropDown2.map(el => <MenuItem translate="no" value={el}>{el}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </>
            }
            </div>

        <Grid style={{marginTop: '30px'}} container spacing={2}>
            <Grid item xs={12} md={6} sm={6}>
            <Button  style={{width: '100%', padding: '10px'}} color="secondary" onClick={props.popupClose}>Cancel</Button>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
            <Button  style={{width: '100%', padding: '10px'}} onClick={handleSave} >Save</Button>
            </Grid>
        </Grid>
            <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
        </div>
        </Dialog>
        </div>
    )
}


export default AvailabilitySelectionsDailyPopup;